export const AUTHORITIES = {
  ADMIN: 'ROLE_ADMIN',
  USER: 'ROLE_USER',
  MANAGER: 'ROLE_MANAGER',
  TECHNICIAN: 'ROLE_TECHNICIAN',
  DRIVER: 'ROLE_DRIVER',
  MAINTENANCE: 'ROLE_MAINTENANCE',
  CHECKLIST: 'ROLE_CHECKLIST',
  TRANSPORTER_ADMIN: 'ROLE_TRANSPORTER_ADMIN',
  TRANSPORTER_USER: 'ROLE_TRANSPORTER_USER',
  TRANSPORTER_MANAGER: 'ROLE_TRANSPORTER_MANAGER',
  TRANSPORTER_DRIVER: 'ROLE_TRANSPORTER_DRIVER',
  MANUFACTURER_ADMIN: 'ROLE_MANUFACTURER_ADMIN',
  MANUFACTURER_USER: 'ROLE_MANUFACTURER_USER',
  MANUFACTURER_MANAGER: 'ROLE_MANUFACTURER_MANAGER',
  MANUFACTURER_TECHNICIAN: 'ROLE_MANUFACTURER_TECHNICIAN',
  REPRESENTATIVE_ADMIN: 'ROLE_REPRESENTATIVE_ADMIN',
  REPRESENTATIVE_USER: 'ROLE_REPRESENTATIVE_USER',
  REPRESENTATIVE_MANAGER: 'ROLE_REPRESENTATIVE_MANAGER',
  REPRESENTATIVE_DRIVER: 'ROLE_REPRESENTATIVE_DRIVER',
};

export const messages = {
  DATA_ERROR_ALERT: 'Internal Error',
};

export const APP_DATE_FORMAT = 'DD/MM/YY HH:mm';
export const APP_DATE_FORMAT_WITHOUT_HOUR = 'DD/MM/YY';
export const APP_TIMESTAMP_FORMAT = 'DD/MM/YY HH:mm:ss';
export const APP_LOCAL_DATE_FORMAT = 'DD/MM/YYYY';
export const APP_LOCAL_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm';
export const APP_WHOLE_NUMBER_FORMAT = '0,0';
export const APP_TWO_DIGITS_AFTER_POINT_NUMBER_FORMAT = '0,0.[00]';
export const APP_DATE_FORMAT_HOUR = 'HH:mm';
export const REGEX_DATE = /^(20)(\d\d-\d{2}-\d{2}T\d{2}:\d{2})$/;
export const APP_TIMESTAMP_FORMAT_YEAR = 'DD/MM/YYYY HH:mm:ss';
export const APP_TIMESTAMP_FORMAT_YEAR_WITHOUT_SEC = 'DD/MM/YYYY HH:mm';
export const APP_DATE_FORMAT_HOUR_WITH_SEC = 'HH:mm:ss';
export const APP_DATE_FORMAT_VALIDATED = 'YYYY-MM-DD';
export const APP_YEAR_FORMAT = 'YYYY';
export const APP_DATETIME_ISO8601_FORMAT = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/; // example: "2024-08-08T07:00:00.000Z" or "2024-08-08T07:00:00Z" (ms part is optional)

export const THREE_MINUTES = 180000;
export const DEFAULT_VIRTUAL_FENCE_COLOR = '#dc3545';

export const FENCE_RISK_COLORS = {
  SAFE: '#2e7d32',
  UNSAFE: '#c62828',
  CONTROL: '#1565c0',
} as const;

export type RiskClassification = 'SAFE' | 'UNSAFE' | 'CONTROL';

export const DEFAULT_FENCE_RISK_CLASSIFICATION: RiskClassification = 'CONTROL';
export const FENCE_RISK_NOTIFICATION_DEFAULT: Record<RiskClassification, boolean> = {
  SAFE: false,
  UNSAFE: true,
  CONTROL: false,
};
export const DEFAULT_FENCE_NOTIFICATION_ENABLED = FENCE_RISK_NOTIFICATION_DEFAULT[DEFAULT_FENCE_RISK_CLASSIFICATION];

export enum ModelsDesign {
  T_1x2 = 'T_1x2',
  T_1x4 = 'T_1x4',
  T_2x4 = 'T_2x4',
  T_2x8 = 'T_2x8',
  T_3x6 = 'T_3x6',
  T_3x12 = 'T_3x12',
  T_4x2 = 'T_4x2',
  T_4x8 = 'T_4x8',
  T_4x16 = 'T_4x16',
  T_6x24 = 'T_6x24',
  T_6x2 = 'T_6x2',
  T_8x2 = 'T_8x2',
}

export enum ColorScheme {
  DARK = 'dark',
  LIGHT = 'light',
}
